// extracted by mini-css-extract-plugin
export default {"logoimage":"Guildhian_logoimage__AvMBb"};